// extracted by mini-css-extract-plugin
export default {"next_order":"Zu","recurringdis":"av","reactivate_button":"bv","order__summary_title":"cv","order__summary_items":"ev","order__summary_item":"fv","order__summary_item_title":"gv","order__summary_item_quantity":"hv","order__item_separator":"iv","discount":"jv","promowrapper":"kv"};
    if(module.hot) {
      // 1713969926431
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  